import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { waLink } from "../config/site";

export const CTASection = ({ serviceName }) => {
  const msg = serviceName
    ? `Hello SparkGrid Solutions! I'm interested in your ${serviceName} service. Let's talk.`
    : "Hello SparkGrid Solutions! I have a project idea. Let's talk.";
  return (
    <section className="bg-silk px-4 pb-24 sm:px-6 lg:px-8" data-testid="cta-section">
      <Reveal>
        <div className="relative mx-auto max-w-7xl overflow-hidden rounded-[2.5rem] bg-night px-6 py-16 text-center sm:px-12 lg:py-24">
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-spark/20 blur-[100px]" />
          <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-ember/20 blur-[100px]" />
          <p className="relative font-mono text-xs uppercase tracking-[0.3em] text-spark">
            {serviceName || "Let's Build Together"}
          </p>
          <h2 className="relative mx-auto mt-4 max-w-3xl font-syne text-3xl font-extrabold tracking-tight text-white sm:text-5xl">
            Have an idea? <span className="bg-gradient-to-r from-spark to-ember bg-clip-text text-transparent">Let's spark it.</span>
          </h2>
          <p className="relative mx-auto mt-4 max-w-xl text-sm text-slate-400 sm:text-base">
            Tell us where you want to go — we'll map the fastest route from idea to launch.
          </p>
          <div className="relative mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link
              to={serviceName ? `/contact?service=${encodeURIComponent(serviceName)}` : "/contact"}
              data-testid="cta-contact-btn"
              className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-spark to-ember px-7 py-3.5 text-sm font-bold text-night transition-transform duration-300 hover:scale-105"
            >
              Start a Project
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
            <a
              href={waLink(msg)}
              target="_blank"
              rel="noreferrer"
              data-testid="cta-whatsapp-btn"
              className="inline-flex items-center gap-2 rounded-full border border-white/20 px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-300 hover:border-wa hover:text-wa"
            >
              <WhatsAppIcon className="h-4 w-4" /> WhatsApp Us
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
